import FocusTrap from "focus-trap-react";
import React, { useState } from "react";
import { useString } from "../../i18n/GetText";
import { useLanguage } from "../../i18n/LanguageContext";
import { Alternate } from "../../model/language";
import { ToolbarRootItem } from "../../model/menu";
import { SanityDocument } from "../../model/common";
import { urlForDocument } from "../../urls";
import Link from "../Link/Link";
import ToolBar from "../Toolbar/ToolBar";
import ToolBarNav from "../Toolbar/ToolBarNav/ToolBarNav";
import styles from "./MainNav.module.scss";
import { findNavMatches } from "./nav";
import SecondaryNav from "./SecondaryNav";
import ToolbarRightNav from "./ToolbarRightNav";
import MicrobitLogo from "../../icons/MicrobitLogo";
import { usePathname } from "../../utils/usePathname";

interface MainNavProps {
  alternates: Alternate[];
  homePage: SanityDocument;
  toolbar: ToolbarRootItem[];
  isErrorPage: boolean;
}

const MainNav = ({
  alternates,
  homePage,
  toolbar,
  isErrorPage
}: MainNavProps) => {
  let pathname = usePathname();
  const language = useLanguage();
  // Avoid using pathname for the 404 page as that will cause SSR issues (as the path is fixed to /404/ or similar server side).
  const [firstLevelMatch, secondLevelMatch, thirdLevelMatch] = isErrorPage
    ? []
    : findNavMatches(pathname, toolbar, language);
  const [showLanguage, setShowLanguage] = useState(false);
  const logoTitle = useString("go-to-home-page");
  const [focusTrapActive, setFocusTrapActive] = useState(false);
  return (
    <>
      <FocusTrap
        active={focusTrapActive}
        focusTrapOptions={{
          escapeDeactivates: false
        }}
      >
        <ToolBar
          setFocusTrapActive={setFocusTrapActive}
          onMobileClose={() => setShowLanguage(false)}
          logo={
            <Link style={{ display: "flex" }} to={urlForDocument(homePage)}>
              <MicrobitLogo title={logoTitle} />
            </Link>
          }
          right={[
            <ToolBarNav key="toolBarNav" className={styles.toolBarNav}>
              <ToolbarRightNav
                alternates={alternates}
                navItems={toolbar}
                firstLevelMatch={firstLevelMatch}
                secondLevelMatch={secondLevelMatch}
                thirdLevelMatch={thirdLevelMatch}
                showLanguage={showLanguage}
                setShowLanguage={setShowLanguage}
              />
            </ToolBarNav>
          ]}
        />
      </FocusTrap>
      {firstLevelMatch &&
        firstLevelMatch.childLinks &&
        firstLevelMatch.childLinks.length > 0 && (
          <SecondaryNav
            items={firstLevelMatch.childLinks}
            leafMatch={secondLevelMatch}
          />
        )}
    </>
  );
};

export default MainNav;
